import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { ModulesManagerService } from '../classes/Module/modules-manager.service';
import { UserService } from '../classes/User/user.service';
import { Browser } from '@capacitor/browser';
//import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';

@Injectable()
export class MenuNaviService {
  private manager: ModulesManagerService;
  constructor(private router: Router, private menu: MenuController/*,private splashScreen: SplashScreen*/) {
    //splashScreen.show() 

    // if(this.getDarkModePreference() == 'true') document.body.classList.add('dark')
  }

  initiate(manager: ModulesManagerService) {
    this.manager = manager;

  }

  removeSpalsh() {
    //this.splashScreen.hide()
  }

  openMenu() {
    this.menu.enable(true, 'menuNavi');
    this.menu.open('menuNavi');
  }

  closeMenu() {
    this.menu.close('menuNavi');
  }

  navigateTo(page: string, params?: any) {
    this.router.navigate([page], { queryParams: params || {} });
  }

  openProfile() {
    if (!this.manager.Usr?.isLoged) return
    this.navigateTo("/account")
  }

  checkLoged(usr: UserService): boolean {
    if (!usr.isLoged) {
      this.navigateTo('/asks');
      return false;
    }
    return true
  }
  isSelected(page: string) {
    return this.router.url.includes("/" + page)
  }

  verifyUrl() {
    let splitedLink = window.localStorage.Href.split("/?")
    if (splitedLink.length > 1) {
      let parsed = this.manager.Tool.linkParser(window.localStorage.Href)
      switch (parsed.Action) {
        case 'reset-password':
        case 'register':
        case 'login':
          this.navigateTo("/" + parsed.Action) // c'est la même chose autant en profiter non ?
          break;
        case 'token':
          this.navigateTo("/confirme-token")
          break;
        default:
          this.navigateTo("/crea", { qr_code: window.localStorage.Href })
          break
      }
    } else {
      const url = new URL(window.localStorage.Href);
      const params = {};
      for (const [key, value] of url.searchParams.entries()) {
        params[key] = value;
      }
      this.navigateTo(url.pathname.split("/").pop(), params);
    }
  }

  public async openLink(url, event: any = null) {
    if (event) event.preventDefault();
    await Browser.open({ url: url });
  }

  public openDocumentPickerPopUp(popup, onDocumentPicker, onUseCamera) {
    popup.presentAlert({
      header: this.manager.Trad.Parse('STR_METHODE_CHOICE'),
      message: this.manager.Trad.Parse('STR_HOW_SHOULD_IMPORT_DOCUMENT'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: "📁 " + this.manager.Trad.Parse('STR_DOCUMENT_PICKER'),
          handler: onDocumentPicker,
        },
        {
          text: "📷 " + this.manager.Trad.Parse('STR_USE_CAMERA'),
          handler: onUseCamera,
        },
        {
          cssClass: 'button-cancel',
          text: this.manager.Trad.Parse('STR_CLOSE'),
        },
      ],
    })
  }

  public setDarkMode(event) {
    // document.body.classList.toggle('dark', event.detail.checked)
    // window.localStorage.isDarkModeActivated = event.detail.checked
  }

  public getDarkModePreference() {
    return false
    //  return window.localStorage.isDarkModeActivated
  }
}
